import template from "./booths.html";
import controller from "./booths.controller";
import "./booths.scss";

const BoothsComponent = {
    template,
    controller,
    controllerAs: "controller"
};

export default BoothsComponent;


// WEBPACK FOOTER //
// ./sources/components/booths/booths-component.js